module.exports = __webpack_public_path__ + "media/customizations/smartlife/logo-ee8a4354348b65ddcf3544e5e4674a34.png";